import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { DELETE_QUESTION } from './constants';
import {
  DeleteQuestionDataActionTypes,
  DeleteQuestionError,
  DeleteQuestionState,
  DeleteQuestionSuccess,
} from './types';

const initialState: DeleteQuestionState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: DeleteQuestionDataActionTypes,
  ): DeleteQuestionState => {
    switch (action.type) {
      case DELETE_QUESTION + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case DELETE_QUESTION + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as DeleteQuestionSuccess).payload;
        break;
      }
      case DELETE_QUESTION + FAILURE: {
        draft.status = rejected;
        draft.error = (action as DeleteQuestionError).error;
        break;
      }
      case DELETE_QUESTION + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
